import { AuthRoleEnum } from '@codezo/graphql';

export function getRedirectUrlForRole(role?: string): string {
	if (role === AuthRoleEnum.Admin) {
		return import.meta.env.VITE_ADMIN_APP_URL;
	};
	return import.meta.env.VITE_PUBLIC_APP_URL;
}

export const handleLoginValidate = async (token: string, role: string) => {
	const redirectUrl = getRedirectUrlForRole(role);
	window.location.href = `${redirectUrl}/auth/callback?token=${token}`;
};
